const Colors = {
  orange: '#CC4E13',
  yellow: '#FFF9E6',
  mildYellow: '#CFB96E',
  darkYellow: '#6F560A',
  blue: '#212944',
  lightTeal: '#11A8A7',
  teal: '#0C7979',
  teal10: '#11A8A710',
  darkTeal: '#0E7271',
  statusReport: '#12806B',
  statusProcessing: '#53608A',
  statusOrdered: '#0F7D9F',
  red: '#ff1744',
  redAlert: '#D00F0E',
  white: '#fff',
  white70: 'rgba(255, 255, 255, 0.7)',
  black: '#000',
  gray: '#666666',

  lightBlueGray: '#F2F3FC',
  darkBlueGray: '#60667B',

  darkGray: '#525D68',
  midGray: '#9EA1A5',
  mildGray: '#F0F0F0',
  milderGray: '#E5E5E5',
  lightGray: '#F9F9F9',
  lightGrayBackground: '#E9E9E9',
  transparentGray: 'rgba(196, 196, 196, 0.4)',
  blueGray: '#E9EBEE',

  blogTeal: '#1C7D98',
  blogCyan: '#2CB8E2',
  blogMint: '#65CCB8',

  supportSuccess: '#086654',
  supportSuccessBorder: '#65CCB8',
  supportSuccessBackground: '#E6FFF9',
};

export default Colors;
